export enum VenueBillingCycle {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum VenueBillingManageAction {
  CHANGE = 'CHANGE',
  CANCEL = 'CANCEL',
}

export enum VenueBillingType {
  RECURRING = 'RECURRING',
}

export enum VenueBillingIntervalUnit {
  MONTH = 'MONTH',
}

export enum VenueBillingSignupStatus {
  MISSING_REQUIRED_INFO = 'MISSING_REQUIRED_INFO',
  READY_TO_SIGNUP = 'READY_TO_SIGNUP',
  SIGNED_UP_PENDING_PAYMENT = 'SIGNED_UP_PENDING_PAYMENT',
  PAYMENT_METHOD_ADDED_PENDING_ACTIVATION = 'PAYMENT_METHOD_ADDED_PENDING_ACTIVATION',
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  CANCELLED = 'CANCELLED',
}

export enum VenueBillingPaymentStatus {
  NOT_STARTED = 'NOT_STARTED',
  PENDING_PAYMENT_METHOD = 'PENDING_PAYMENT_METHOD',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  CANCELLED = 'CANCELLED',
}

export enum VenueBillingLifecycleSource {
  SIGNUP_SUBMIT = 'signup_submit',
  ZOHO_SYNC = 'zoho_sync',
  BACKFILL = 'backfill',
}
